module.exports = __webpack_public_path__ + "media/images/thanksgiving/bg-md-a7f4c37e239359c8130200d79366a908.jpg";